module.exports = __webpack_public_path__ + "static/media/trainerBanner-akt.eae947c7.jpg";